import { assoc, reduce } from 'ramda';
import { combineReducers } from 'redux';

import { addItem } from '../utils/functional';
import { LOAD_EXTENSION, LOAD_EXTENSION_ERROR, LOAD_EXTENSION_SUCCESS } from './constants';

const byId = (state = {}, { type, payload }) => {
  switch (type) {
    case LOAD_EXTENSION_SUCCESS:
      return assoc(payload.id, payload, state);
    default:
      return state;
  }
};

const byShopId = (state = {}, { type, payload }) => {
  switch (type) {
    case LOAD_EXTENSION_SUCCESS:
      return reduce(
        (prevState, shopId) => assoc(shopId, payload, prevState),
        state,
        payload.shops
      );
    default:
      return state;
  }
};

const byRoute = (state = {}, { type, payload }) => {
  switch (type) {
    case LOAD_EXTENSION_SUCCESS:
      return assoc(payload.route, payload, state);
    default:
      return state;
  }
};

const list = (state = [], { type, payload }) => {
  switch (type) {
    case LOAD_EXTENSION_SUCCESS:
      return addItem(payload.id, state);
    default:
      return state;
  }
};

const busy = (state = false, { type }) => {
  switch (type) {
    case LOAD_EXTENSION:
      return true;
    case LOAD_EXTENSION_ERROR:
    case LOAD_EXTENSION_SUCCESS:
      return false;
    default:
      return state;
  }
};

const loadingList = (state = [], { type, payload }) => {
  switch (type) {
    case LOAD_EXTENSION:
      return [...state, payload];
    case LOAD_EXTENSION_ERROR:
      return state.filter(item => item !== payload.idOrRoute);
    case LOAD_EXTENSION_SUCCESS:
      return state.filter(item => ![payload.id, payload.route, ...payload.shops].includes(item));
    default:
      return state;
  }
};

const error = (state = null, { type, payload }) => {
  switch (type) {
    case LOAD_EXTENSION_ERROR:
      return payload.error;
    case LOAD_EXTENSION_SUCCESS:
      return null;
    default:
      return state;
  }
};

export default combineReducers({
  byId,
  byShopId,
  byRoute,
  list,
  busy,
  loadingList,
  error,
});




// WEBPACK FOOTER //
// ./src/app/extensions/reducer.js